import isLockerInactive from "@components/Lockers/_lib/isLockerInactive";

// White-on-grey, contrast 4.5:1 — the carrier badge and the map marker both use white text
const INACTIVE_COLOR = "#767676";

const getProviderData = (marker) => {
  switch (marker.provider) {
    case "fancurier":
      return {
        name: "FANbox",
        color: "#2CAAE1",
      };
    default: {
      return {
        name: "Locker",
        color: "#fff",
      };
    }
  }
};

const getLockerProviderData = (marker) => {
  const providerData = getProviderData(marker);

  return isLockerInactive(marker)
    ? { ...providerData, color: INACTIVE_COLOR }
    : providerData;
};

export default getLockerProviderData;
